<template>
  <v-expansion-panels v-model="panel" flat multiple>
    <v-expansion-panel>
      <v-expansion-panel-header color="primary" class="py-0">
        <div v-if="getTitle" class="titlepanelcardtext" v-html="getTitle"></div>
        <template v-slot:actions>
          <v-icon color="white">help</v-icon>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content color="primary">
        <v-card flat color="primary">
          <v-card-text class="panelcardtext pa-0">
            <span v-if="getText">
              <span
                v-if="needHtml"
                v-html="getText"
                @click="handleClick"
              ></span>
              <span v-else>{{ getText }}</span>
            </span>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: {
    titleParams: {
      type: Object
    },
    descParams: {
      type: Object
    },
    titlePath: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    needHtml: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      panel: [0]
    };
  },
  computed: {
    customDataExist() {
      return !!this.titleParams;
    },
    getTitle() {
      if (this.titlePath) {
        return this.$t(this.titlePath, { ...this.titleParams });
      }
      return null;
    },
    getText() {
      if (this.text) {
        return this.$t(this.text);
      }
      return null;
    }
  },
  methods: {
    handleClick(e) {
      if (e.target.classList.contains("operatorInstructionInfo")) {
        this.openConfirmDialog("operators.newPage.instructionInfo");
      }
    },
    openConfirmDialog(instructionKey) {
      let confirmConfig = {
        title: `${instructionKey}.title`,
        message: `${instructionKey}.text`,
        cancelBtnLabel: null,
        confirmBtnLabel: `${instructionKey}.closeBtnLabel`,
        confirmBtnClb: null
      };
      this.$store.commit("confirm/openConfirmDialog", confirmConfig, {
        root: true
      });
    }
  }
};
</script>

<style scoped>
.titlepanelcardtext {
  font-size: 20px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: "Roboto", sans-serif !important;
  color: white;
  background-color: #17365d !important;
}
.panelcardtext {
  color: #fff !important;
  caret-color: #fff !important;
  font-size: 16px !important;
  font-weight: 400;
  font-style: italic;
}
.panelcardtextsession {
  color: #fff !important;
  background-color: #17365d !important;
  font-size: 17px !important;
  font-weight: bold;
}
.toolbar >>> .v-toolbar__content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
